import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/notification`;

const NotificationService = {
    createMultipleNotification: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/create-multiple`, data);
    },

    getNotificationHistories: (params: any): Promise<AxiosResponse> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search,
            type: params?.type,
        };
        return instanceAxios.get(`${BASE_URL}/list-notifications-histories`, {
            params: queryParams,
        });
    },

    viewNotificationHistories: (id: string, params: any): Promise<AxiosResponse> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search,
        };
        return instanceAxios.get(`${BASE_URL}/view-notifications-histories/${id}`, {
            params: queryParams,
        });
    },
};

export default NotificationService;